import { trackLinkInMatomoAndGA } from './CombinedGAMatomo';
import { querySelectorAllWithShadowed } from 'Shared/utils/shadow-wrapper';

const trackableLinks = querySelectorAllWithShadowed(
   '[data-analytics-event-category]'
) as unknown as Array<HTMLElement>;

trackableLinks.forEach(link => {
   const category = link.dataset.analyticsEventCategory;
   const eventName = link.dataset.analyticsEventName;
   trackLinkInMatomoAndGA(link, {
      eventCategory: category,
      eventAction: `${category} - Click - ${eventName}`,
   });
});
